import { Button, Row, Tooltip } from "@narmi/design_system";
import { useContext } from "react";
import BackCancelButton from "../BackCancelButton";
import ContextForm from "../ContextForm";
import "./index.scss";

type StickyProgressButtonsProps = {
  backLabel: string;
  nextLabel: string;
  onBack: () => void;
  onNext: () => void;
  hidePrev?: boolean;
  disableNext?: boolean;
  disabled?: boolean;
  isNextLoading?: boolean;
  dangerouslyDisableShowLoading?: boolean;
  shouldHideInlineToasts?: boolean;
  nextTestId?: string;
  backTooltip?: string;
  nextTooltip?: string;
  kind?: "primary" | "secondary" | "tertiary";
};

/**
 * Sticky footer progress buttons for mobile views.
 * Fixed to bottom of viewport with NDS Button + BackCancelButton.
 */
const StickyProgressButtons = ({
  backLabel,
  nextLabel,
  onBack,
  onNext,
  hidePrev,
  disableNext = false,
  disabled = false,
  isNextLoading = false,
  dangerouslyDisableShowLoading,
  shouldHideInlineToasts,
  nextTestId = "next",
  backTooltip,
  nextTooltip,
  kind = "primary",
}: StickyProgressButtonsProps) => {
  const formContext = useContext(ContextForm.FormContext);

  const getNextButton = () => {
    const next = (
      <Button
        kind={kind}
        size="s"
        endIcon="chevron-right"
        label={nextLabel}
        onClick={formContext ? () => {} : onNext}
        disabled={disableNext}
        isLoading={isNextLoading}
        className="sticky-progress-buttons-next"
        testId={nextTestId}
      />
    );
    return nextTooltip ? <Tooltip text={nextTooltip}>{next}</Tooltip> : next;
  };

  const getBackButton = () => {
    if (hidePrev) return null;
    const back = <BackCancelButton onBack={onBack} backLabel={backLabel} disabled={disabled} />;
    return backTooltip ? <Tooltip text={backTooltip}>{back}</Tooltip> : back;
  };

  return (
    <div className="sticky-progress-buttons-footer">
      <div className="sticky-progress-buttons-container">
        <Row justifyContent="space-between" alignItems="center">
          <Row.Item>{getBackButton()}</Row.Item>
          <Row.Item shrink>
            {formContext ? (
              <ContextForm.Action
                onSubmit={onNext}
                dangerouslyDisableShowLoading={dangerouslyDisableShowLoading}
                shouldHideInlineToasts={shouldHideInlineToasts}
              >
                {getNextButton()}
              </ContextForm.Action>
            ) : (
              getNextButton()
            )}
          </Row.Item>
        </Row>
      </div>
    </div>
  );
};

export default StickyProgressButtons;
